import script from "./DevelopmentHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./DevelopmentHistory.vue?vue&type=script&lang=ts&setup=true"

import "./DevelopmentHistory.vue?vue&type=style&index=0&id=d5f2b990&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5f2b990"]])

export default __exports__